import { formatDate } from '@angular/common'
import { Injectable } from '@angular/core'

import {
  NUMBER_ONE_HUNDRED_TWENTY_SIX,
  NUMBER_THIRTY_TWO,
  NUMBER_ZERO,
} from '../../../constants/constant.numbers'
import { FilterGroup } from '../data-filters/models/filter-group-enum'
import { IFilterState } from '../data-filters/models/ifilter-state'

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  static wordMatch(word1: string, word2: string): boolean {
    if (word1 && word2) {
      return (
        this.wordCheck(word1).trim().toLowerCase() ===
        this.wordCheck(word2).trim().toLowerCase()
      )
    }
    return false
  }

  static wordCheck(word: string): string {
    if (!word) {
      return word
    }
    let newWord: string
    for (let i = 0; i < word.length; i++) {
      let ch: any = word.charAt(i)
      if (
        word.charCodeAt(i) < NUMBER_THIRTY_TWO ||
        word.charCodeAt(i) > NUMBER_ONE_HUNDRED_TWENTY_SIX
      ) {
        ch = ' '
      }
      newWord = newWord + ch
    }
    return newWord
  }

  // eslint-disable-next-line complexity
  trimPolarisFundName(fund: any) {
    const FIX_NAME_REGEX = new RegExp('(?:vanguard |shares)', 'ig')
    let trimmedFName: any, fundSymbol: any
    if (fund) {
      if (fund && fund.fundFullName && fund.fundShortName !== undefined) {
        trimmedFName =
          fund.fundFullName.replace(FIX_NAME_REGEX, '') || fund.fundShortName
      }
      fundSymbol = fund.ticker || fund.portId
      fund.fundName = trimmedFName
      fund.fundSymbol = fundSymbol
    }
    return fund
  }

  getClosedIndicatorForFund(fund): boolean {
    const fundId = fund.portId
    let closedIndicator = false
    if (fund.newAccount === 'Not Available') {
      closedIndicator = true
    }

    if (fundId === '0082' || fundId === '0111' || fundId === '5111') {
      closedIndicator = true
    }
    return closedIndicator
  }

  setPolarisFees(fund, polarisFeeReturns) {
    const feeLists = fund.feeList
    const date = formatDate(new Date(), 'yyyy-MM-dd', 'en-US')
    if (feeLists !== undefined && feeLists !== 0) {
      feeLists.forEach((feeObj) => {
        if (feeObj.code === 'PURC' && feeObj.endDate >= date) {
          polarisFeeReturns.purchaseFee = feeObj.percent
        }
        if (feeObj.code === 'REDM' && feeObj.endDate >= date) {
          polarisFeeReturns.redemptionFee = feeObj.percent
        }
      })
    }
    return polarisFeeReturns
  }

  static existAnyWordMatch(wordArray: string[], word2: string): boolean {
    let isAnyWordMatchFound = false
    if (wordArray && word2) {
      wordArray.forEach((word) => {
        if (!isAnyWordMatchFound) {
          isAnyWordMatchFound =
            this.wordCheck(word).trim().toLowerCase() ===
            this.wordCheck(word2).trim().toLowerCase()
        }
      })
    }
    return isAnyWordMatchFound
  }
  static isAllShareClassOptionApplicable(filterState: IFilterState): boolean {
    let count: number = NUMBER_ZERO
    if (
      !UtilityService.isEmpty(
        filterState.getFilterSelections(FilterGroup.ProductTypeFilterGroup),
      )
    ) {
      filterState
        .getFilterSelections(FilterGroup.ProductTypeFilterGroup)
        .forEach((filterSelectionStr) => {
          if (
            filterSelectionStr === 'collTrusts' ||
            filterSelectionStr === 'etf'
          ) {
            count += 1
          }
        })
      return (
        filterState.getFilterSelections(FilterGroup.ProductTypeFilterGroup)
          .length !== count
      )
    }
    return true
  }
  static isEmpty(collection: any[]) {
    return !(collection && collection.length > 0)
  }

  convertLitDataStrToArray(str: string): string[] {
    let literatureData: Array<string> = new Array<string>()
    if (str) {
      literatureData = str.match(/[^,]+/g)
    }
    return literatureData
  }
}
